const ID = {
    header: 'fb-page-header',
    title: 'fb-page-title'
}

const CLASSES = {
    headerRounded: "page-header--rounded",
    headerNotRounded: "page-header--not-rounded",
    // headerNoBorder: "page-header--default--no-border"
}

const pageHeader = document?.getElementById(ID.header);
const pageTitle = document?.getElementById(ID.title);

const checkPageTitle = () => {
    if (pageTitle != null && pageTitle.innerText === "Help and support") {
        updatePageHeaderClass();
    }
}

const updatePageHeaderClass = () => {
    // pageHeader.classList.add(CLASSES.headerNoBorder);
    pageHeader.classList.remove(CLASSES.headerRounded);
    pageHeader.classList.add(CLASSES.headerNotRounded);
}

export default {
    checkPageTitle
}